export default "__VITE_ASSET__B8DNr1Wx__"